import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PesquisaGeralService } from '../services/pesquisa-geral.service';

@Injectable({
  providedIn: 'root'
})
export class PesquisaGeralResolver implements Resolve<boolean> {

  constructor(private service: PesquisaGeralService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.listFilters();
  }
}

